import { useEffect, useState } from 'react';
import { motion } from 'motion/react';
import { mascaraTelefone } from '@/pages/inscricao/utils';

interface DadosCompradorProps {
  nome: string;
  whatsapp: string;
  erros: { nome?: string; whatsapp?: string };
  /** Cada toque no Pagar incompleto soma 1: o cartão dá o "tremidinho". */
  tremer?: number;
  onNome: (v: string) => void;
  onWhatsapp: (v: string) => void;
  onBlurWhatsapp?: () => void;
}

// Seu nome + WhatsApp de quem está participando (sem identificação individual).
// Só aparece quando a participação não pede dados por ingresso (convite/gratuito)
// e a pessoa ainda não tem carteira neste celular nem está logada.
export default function DadosComprador({
  nome,
  whatsapp,
  erros,
  tremer = 0,
  onNome,
  onWhatsapp,
  onBlurWhatsapp,
}: DadosCompradorProps) {
  // Tremidinho horizontal (±4 px, 2 vezes, 200 ms) quando falta preencher.
  const [sacudir, setSacudir] = useState(false);
  useEffect(() => {
    if (!tremer) return;
    if (!erros.nome && !erros.whatsapp) return;
    setSacudir(true);
    const t = window.setTimeout(() => setSacudir(false), 220);
    return () => window.clearTimeout(t);
  }, [tremer, erros.nome, erros.whatsapp]);

  return (
    <motion.div
      animate={sacudir ? { x: [0, -4, 4, -4, 4, 0] } : { x: 0 }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
      className="rounded-[18px] bg-background-50 p-5 shadow-pcard md:p-6"
    >
      <h2 className="text-base font-bold text-foreground-950">Seu nome e WhatsApp</h2>
      <p className="mt-1 text-sm text-foreground-600">
        É por aqui que você recebe e recupera seus ingressos.
      </p>

      <div className="mt-5 space-y-4">
        <div className="relative">
          <label
            htmlFor="ingresso-nome-comprador"
            className="absolute -top-2 left-3 bg-white/90 px-1 text-xs font-medium text-foreground-600"
          >
            Seu nome *
          </label>
          <div className="flex items-center overflow-hidden rounded-xl border border-secondary-300 bg-white">
            <span className="flex h-12 w-12 items-center justify-center text-foreground-400">
              <i className="ri-user-line text-lg" />
            </span>
            <input
              id="ingresso-nome-comprador"
              type="text"
              value={nome}
              onChange={(e) => onNome(e.target.value)}
              placeholder="Maria da Silva"
              autoComplete="name"
              className="flex-1 bg-transparent py-3 pr-4 text-sm text-foreground-900 outline-none"
            />
          </div>
          {erros.nome && (
            <p className="mt-1 text-sm text-danger-600" role="alert" data-erro="true">
              {erros.nome}
            </p>
          )}
        </div>

        <div className="relative">
          <label
            htmlFor="ingresso-whatsapp-comprador"
            className="absolute -top-2 left-3 bg-white/90 px-1 text-xs font-medium text-foreground-600"
          >
            Seu WhatsApp *
          </label>
          <div className="flex items-center overflow-hidden rounded-xl border border-secondary-300 bg-white">
            <span className="flex h-12 w-12 items-center justify-center text-green-600">
              <i className="ri-whatsapp-line text-lg" />
            </span>
            <input
              id="ingresso-whatsapp-comprador"
              type="tel"
              inputMode="numeric"
              value={whatsapp}
              onChange={(e) => onWhatsapp(mascaraTelefone(e.target.value))}
              onBlur={onBlurWhatsapp}
              placeholder="(00) 00000-0000"
              autoComplete="tel"
              className="flex-1 bg-transparent py-3 pr-4 text-sm text-foreground-900 outline-none"
            />
          </div>
          {erros.whatsapp && (
            <p className="mt-1 text-sm text-danger-600" role="alert" data-erro="true">
              {erros.whatsapp}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
}